export default __webpack_public_path__ + "static/mui-02e6a3f84f0c2e0c7db2b7a8f0a920bb.png";